import React from "react";
import { CellData } from "./table";
import { TableCell } from "./tableCell/tableCell";

interface TableBodyProps {
  computedCellData: CellData[][];
  tableDataToRender: any[];
  tableWidth: number;
  onRowClick: (tableData: any[], rowIndex: number, className: string) => void;
  onTableRowUpdate?: (
    rowIndex: number,
    fieldKey: string,
    newValue: any,
  ) => void;
  /** Fired when a CLICKABLE_BADGE_WITH_ON_CLICK cell is clicked; receives the cell `id`. */
  onClickableBadgeClick?: (id: string) => void;
  startIndex?: number;
  rowClassName?: string | ((rowData: any, rowIndex: number) => string);
}

/**
 * Renders the table body from pre-computed cell data.
 *
 * @param props - Cell matrix and row/cell click handlers
 * @returns Table body element
 */
const TableBody: React.FC<TableBodyProps> = ({
  computedCellData,
  tableDataToRender,
  onRowClick,
  onClickableBadgeClick,
  startIndex,
  rowClassName,
}) => {
  return (
    <tbody>
      {computedCellData.map((rowData, rowIndex) => {
        const currentRow = rowData[0]?.rowData;
        const rowKey = currentRow?.id ?? `row-${rowIndex}`;
        const extraRowClass =
          typeof rowClassName === "function"
            ? rowClassName(currentRow, rowIndex)
            : (rowClassName ?? "");
        return (
          <tr
            key={rowKey}
            style={{ display: "flex", width: "100%" }}
            className={extraRowClass}
          >
            {rowData.map((cell, cellIndex) => (
              <td
                key={cellIndex}
                className={`table-cell ${cell.type}__${cell.header}`}
                style={{
                  width: `${cell?.width}%`,
                }}
                onClick={() =>
                  onRowClick(
                    tableDataToRender,
                    rowIndex,
                    `table-cell ${cell.type}__${cell.header}`,
                  )
                }
              >
                <TableCell
                  type={cell.type}
                  value={cell.value}
                  header={cell.header}
                  rowData={cell.rowData}
                  onClickableBadgeClick={onClickableBadgeClick}
                />
              </td>
            ))}
          </tr>
        );
      })}
    </tbody>
  );
};

export default TableBody;
